Wee.fn.make('navigation', {
	init: function() {
		var priv = this.$private;

		$.screen.map([
			{
				max: 3,
				callback: function() {
					priv.bindMobileNav();
				},
				namespace: 'navigation'
			},
			{
				min: 4,
				callback: function() {
					priv.unbindMobileNav();
				},
				namespace: 'navigation'
			}
		]);
	}
}, {
	/**
	 * Bind mobile navigation events
	 *
	 * @private
	 */
	bindMobileNav: function() {
		$('ref:menuToggle').on('click.mobileNav', function(e, el) {
			var $el = $(el);

			! $el.isSelected() ?
				this.enableMobileNav() :
				this.disableMobileNav();

			e.stopPropagation();
		}, {
			scope: this
		});

		$(Wee._doc).on('click.mobileNav', this.disableMobileNav.bind(this));
	},

	/**
	 * Unbind mobile navigation events
	 *
	 * @private
	 */
	unbindMobileNav: function() {
		$('ref:menuToggle').off('click.mobileNav');

		$(Wee._doc).off('click.mobileNav');

		this.disableMobileNav();
	},

	/**
	 * Enable mobile navigation
	 *
	 * @private
	 */
	enableMobileNav: function() {
		$('ref:menuToggle').select();

		$('ref:menu').enable();

		$(Wee._body).addClass('-no-scroll');
	},

	/**
	 * Disabled mobile navigation
	 *
	 * @private
	 */
	disableMobileNav: function() {
		$('ref:menuToggle').unselect();

		$('ref:menu').disable();

		$(Wee._body).removeClass('-no-scroll');
	}
});